export const STORE_KEY = '$_user';
